import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import moment from "moment";
// others
import { Loading } from "./index";
import Button from "../../../../molecules/Button";
import { DownloadOutlined } from "@ant-design/icons";
import PdfView from "../../../../molecules/PDFViewer/pdvViewNew";
import { Row, Col, Form, message, Image, Upload, Space, Radio, Switch, Tooltip, Spin, Select, Modal } from "antd";
import { useForm, useWatch } from "react-hook-form";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { InputNumberFieldV2 as InputNumberField } from "../../../../atoms/FormElement/InputNumberField";
import { dateBookingDDMMYYFormat } from "../utils";
import { calculatePaidAmountAndDueDate } from "../utils";
import { uploadDocumentMedia, getPresignedImage } from "../../../../../utils/media";
import { updateBooking, getBookingDetail } from "../../ducks/actions";

import { DateField, InputField, ReactSelectField, InputCheckbox } from "../../../../atoms/FormElement";

import { datePlaceholderddmmyyFormat } from "../utils";

interface IProps {
  renewal?: boolean;
  parentState: (obj: object) => void;
}

let initialState = {
  visible: false,
  authorizedSignatory: "",
};

import { ExclamationCircleFilled, LinkOutlined, UploadOutlined } from "@ant-design/icons";
import { getMoveOutDetailService } from "../../../TerminationProcess/ducks/services";
import { PopupConfirm } from "../../../../atoms/Popup";
import { useTotalOverpaymentAmount } from "../../../Contracts/PostDatedCheques/ModifyPaymentStatus/hook/useTotalOverpaymentAmount";
import { formatCurrency } from "../../../../libs/utils";
import { useDebouncedAsync } from "../../../TerminationProcess/hooks/useDebouncedAsync";
import { usePendingRequestsActions } from "../../../PendingApprovalRequets/api/useRefreshPendingRequests";
import { convertToNormalCase } from "../../../Contracts/PostDatedCheques/ReceiptMultiInvoiceAllocation/utils";
import {
  buildMoveOutBody,
  getOverStayPenaltyValue,
  getTerminationPaneltyValue,
  getLinkedInvoiceAmount,
  getOtherReceivablesTotal,
  LinkedInvoice,
  LinkedInvoicePaymentType,
  LinkedInvoicesState,
  linkedInvoiceFieldLabels,
  isLinkedInvoicePaid,
  MoveOutDetail,
  parseCurrency,
  penaltyOption,
  PenaltyType,
  resolveLinkedInvoicesFromSummary,
  UploadedDocData,
} from "./EditTerminationProcess.utils";
import { LinkedInvoicesGrid } from "./LinkedInvoicesGrid";

const TooltipContent = ({ data, type }) => {
  if (type === 1) {
    return (
      <div>
        {/* totalOverStayPaneltyAmount	2040 type	*/}
        <span>Penalty type = {data?.type}</span>
        <br />
        <span>Amount per day = {data?.amount}</span>
        <br />
        <span>VAT = {data?.vat}</span>
        <br />
        <span>Overstay days = {data?.numberOfDays}</span>
        <br />
        <span>
          Overstay penalty vat ={" "}
          {`(OverStay days)% * (Amount per day) = ${formatCurrency(data?.overStayPaneltyVatAmount, { showZeros: true })}`}
        </span>
        <br />
        {data?.type?.toLowerCase() === "amount" ? (
          <>
            <span>
              Total overstay penalty ={" "}
              {`(Overstay days  * Amount per day) + VAT % = ${formatCurrency(data?.totalOverStayPaneltyAmount, { showZeros: true })}`}
            </span>
            <br />
          </>
        ) : (
          <>
            <span>
              Total overstay penalty ={" "}
              {`((Rent per day * overstayPenaltyAmount)/100) * Amount per day + VAT %  = ${formatCurrency(
                data?.totalOverStayPaneltyAmount,
                { showZeros: true },
              )}`}
            </span>
            <br />
          </>
        )}
      </div>
    );
  } else {
    return (
      <div>
        <span>Penalty type = {data?.type}</span>
        <br />
        {
          <>
            {" "}
            <span>Penalty amount= {data?.amount}</span>
            <br />
          </>
        }
        <span>VAT = {data?.vat}</span>
        <br />
        <span>Number of days = {data?.numberOfDays}</span>
        <br />
        {data?.type?.toLowerCase() === "amount" ? (
          <>
            <span>
              Termination Penalty amount ={" "}
              {`(Number of days * Penalty amount) =  ${formatCurrency(data?.terminationPaneltyAmount, { showZeros: true })}`}
            </span>
            <br />
          </>
        ) : (
          <>
            <span>
              Termination Penalty amount ={" "}
              {`(Amount per month * Penalty amount) =  ${formatCurrency(data?.terminationPaneltyAmount, { showZeros: true })}`}
            </span>
            <br />
          </>
        )}
        <span>
          Penalty vat amount ={" "}
          {`(termination Penalty amount * VAT) / 100 = ${formatCurrency(data?.terminationPaneltyVatAmount, { showZeros: true })}`}
        </span>
        <br />

        <>
          <span>
            Total Termination penalty ={" "}
            {`(Termination Penalty amount * Penalty vat amount) = ${formatCurrency(
              data?.totalterminationPaneltyAmount,
              { showZeros: true },
            )}`}
          </span>
          <br />
        </>
      </div>
    );
  }
};

const index = (props: IProps) => {
  // hooks initialization
  const dispatch: any = useDispatch();
  const { leaseId = "" } = useParams();
  const { refreshPendingRequests } = usePendingRequestsActions();
  const { bookingDetails } = useSelector((state: any) => state.newBooking);
  const { totalOverpaymentRemaining } = useTotalOverpaymentAmount(bookingDetails?.tenantId);
  const [viewOrDownloadUrl, setViewOrDownloadUrl] = useState(null);
  const [openFileView, setOpenFileView] = useState(false);
  const {
    control,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const watchedValues = useWatch({
    control,
    name: ["overStayPenalty", "terminationPenalty"],
  });

  // states

  const [{ visible }, setState] = useState(initialState);
  const [uploadedDocData, setUploadedDocData] = useState<UploadedDocData | null>(null);

  const updateState = (state: {}) => setState((prevState: any) => ({ ...prevState, ...state }));
  const [moveOutDetail, setMoveOutDetail] = useState<MoveOutDetail | null>(null);
  const [linkedInvoices, setLinkedInvoices] = useState<LinkedInvoicesState>({});
  const [activeLinkedInvoiceField, setActiveLinkedInvoiceField] = useState<LinkedInvoicePaymentType | null>(null);
  const valueBeforeLinkedInvoiceRef = useRef<Partial<Record<LinkedInvoicePaymentType, any>>>({});

  const linkedInvoiceIds = useMemo(
    () => Object.values(linkedInvoices || {}).map((invoice) => invoice?.pdcId).filter(Boolean),
    [linkedInvoices],
  );
  const filteredLinkedInvoiceOptions = useMemo(() => {
    const excludedDescriptions = ["rent_installment", "ejari", "ejari_fee", "security_deposit", "security deposit","general_reduction"];

    return (moveOutDetail?.paymentSchedule || []).filter((invoice) => {
      const description = String(invoice?.description || "").toLowerCase();

      return !excludedDescriptions.includes(description) && isLinkedInvoicePaid(invoice);
    });
  }, [moveOutDetail?.paymentSchedule]);
  const hasUserChangedPenaltyRef = useRef(false);

  const { loading: penaltyChangeLoading } = useDebouncedAsync({
    fn: async () => {
      if (!hasUserChangedPenaltyRef.current) {
        return null;
      }

      hasUserChangedPenaltyRef.current = false;
      const formValues = getValues();
      const body = buildMoveOutBody({
        data: formValues,
        type: 2,
        overStayPenaltyType,
        terminationPenaltyType,
        moveOutDetail,
        uploadedDocData,
        howShowFinalAmount,
        totalOverpaymentRemaining,
        linkedInvoices,
      });
      let checkOverStay = overStayPenaltyType || moveOutDetail?.overStayPenalty?.type;
      let terminationType = terminationPenaltyType || moveOutDetail?.earlyTerminationPenalty?.type;
      let response = null;
      if (checkOverStay === "percentage" && formValues?.overStayPenalty <= 100) {
        response = await dispatch(updateBooking({ leaseId, body }));
      }

      if (terminationType === "month" && formValues?.overStayPenalty <= 12) {
        response = await dispatch(updateBooking({ leaseId, body }));
      }

      if (terminationPenaltyType !== "month" || overStayPenaltyType !== "percentage") {
        response = await dispatch(updateBooking({ leaseId, body }));
      }

      if (response?.data?.code === 200) {
        getMoveOutDetail();
      }

      return response;
    },
    delay: 800,

    params: watchedValues, // 🔥 triggers when values change
  });

  const onSubmit = async (data: any, type) => {
    if (
      data?.moveOutConfirm === true &&
      data?.moveOutConfirm !== "" &&
      data?.moveOutInspectionDate !== "" &&
      data?.moveOutInspectionDate &&
      data?.moveOutDate
    ) {
      PopupConfirm({
        title: `This action requires manager approval.`,
        onOk: async () => {
          try {
            updateState({ visible: true });
            let dataCopy = { ...(data || getValues()) };
           
            const body = buildMoveOutBody({
              data: dataCopy,
              type,
              overStayPenaltyType,
              terminationPenaltyType,
              moveOutDetail,
              uploadedDocData,
              howShowFinalAmount,
              totalOverpaymentRemaining,
              linkedInvoices,
            });
            const response = await dispatch(updateBooking({ leaseId, body: body }));

            if (response?.data?.code === 200) {
              dispatch(getBookingDetail(leaseId + `?moveout=yes`));
              await refreshPendingRequests();
              message.success(response.data.message);
              updateState({ visible: false });
              props.parentState({
                modalPayload: {
                  iKey: "",
                  title: "",
                  extraText: "",
                  open: false,
                },
              });
            }
          } catch (error) {
            updateState({ visible: false });
            props.parentState({ visible: false });
            message.error(error.response?.data?.error || error.response?.data?.message);
          }
        },
        okText: "Yes",
        onCancel() {
          updateState({ visible: false });
          props.parentState({ visible: false });
        },
      });
    } else if (
      data?.moveOutConfirm === true &&
      data?.moveOutConfirm !== "" &&
      (data?.moveOutInspectionDate === "" || !data?.moveOutInspectionDate) &&
      data?.moveOutDate
    ) {
      message.error("Enter Move-out Inspection Date");
      return false;
    } else {
      message.error("please mark complete before submit");
      return false;
    }
  };

  const { totalPaidAmount, lastPaidDate, securityDepositAmount, securityDepositDate } = useMemo(
    () => calculatePaidAmountAndDueDate(moveOutDetail?.paymentSchedule),
    [moveOutDetail?.actualRentDue],
  );

  const fileProps = {
    className: "file-upload",
    name: "file",
    accept: ".jpg,.png,.jpeg,.pdf",
    multiple: false,
    showUploadList: false,
    onChange(info) {
      const { status } = info.file;
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} Please upload only image file`);
      }
    },

    beforeUpload: async (file) => {
      try {
        let uploadConfirmation = await uploadDocumentMedia({
          file_asset: file,
        });
        if (uploadConfirmation?.data?.code === 200) {
          message.success(`file uploaded successfully.`);
          setUploadedDocData(uploadConfirmation?.data?.result);
        }

        return false;
      } catch ({ response }) {
        message.error(response?.data?.error);
      }
    },
  };

  const preViewDoc = async (docId) => {
    let documentId = uploadedDocData?.documentId ? uploadedDocData?.documentId : docId;
    const url = await getPresignedImage([documentId]);
    if (url && url.length > 0) {
      window.open(url[0], "_blank");
    }
  };

  let diffBtwRentDueAndRentReceived = moveOutDetail?.actualRentDue ? moveOutDetail?.actualRentDue : 0 - totalPaidAmount;

  const terminationAndPenaltySum = useMemo(() => {
    const terminationAmount = linkedInvoices.terminationCharges
      ? getLinkedInvoiceAmount(linkedInvoices.terminationCharges)
      : Number(moveOutDetail?.termination?.totalterminationPaneltyAmount) || 0;
    const overstayAmount = linkedInvoices.Overstay
      ? getLinkedInvoiceAmount(linkedInvoices.Overstay)
      : Number(moveOutDetail?.overstay?.totalOverStayPaneltyAmount) || 0;

    return terminationAmount + overstayAmount;
  }, [
    linkedInvoices,
    moveOutDetail?.termination?.totalterminationPaneltyAmount,
    moveOutDetail?.overstay?.totalOverStayPaneltyAmount,
  ]);

  let [vacatingDate, seVacatingDate] = useState(bookingDetails?.vacatingDate);
  const [maintenanceCharges, setMaintenanceCharges] = useState(0);
  const [refurbismentCharges, setRefurbismentCharges] = useState(0);
  const [adminCharges, setAdminCharges] = useState(0);
  const [deductionCharges, setDeductionCharges] = useState(0);
  const [terminationPenaltyType, setTerminationPenaltyType] = useState<PenaltyType>(null);
  const [overStayPenaltyType, setOvertStayPenaltyType] = useState<PenaltyType>(null);
  const otherReceivables = useMemo(() => getOtherReceivablesTotal(linkedInvoices), [linkedInvoices]);

  const getAdminPaidCharges = () => {
    const maintenanceFeeAmount = linkedInvoices.maintenanceFee
      ? getLinkedInvoiceAmount(linkedInvoices.maintenanceFee)
      : maintenanceCharges;
    const refurbismentFeeAmount = linkedInvoices.refurbismentFee
      ? getLinkedInvoiceAmount(linkedInvoices.refurbismentFee)
      : refurbismentCharges;
    const adminFeeAmount = linkedInvoices.adminFee
      ? getLinkedInvoiceAmount(linkedInvoices.adminFee)
      : adminCharges;

    return (
      maintenanceFeeAmount +
      diffBtwRentDueAndRentReceived +
      refurbismentFeeAmount +
      adminFeeAmount +
      terminationAndPenaltySum
    );
  };

  const adminSidePaid = useMemo(
    () => getAdminPaidCharges(),
    [
      linkedInvoices,
      maintenanceCharges,
      refurbismentCharges,
      adminCharges,
      diffBtwRentDueAndRentReceived,
      terminationAndPenaltySum,
    ],
  );

  const tenantSidePaid = useMemo(
    () => deductionCharges + securityDepositAmount + totalPaidAmount + totalOverpaymentRemaining,
    [deductionCharges, securityDepositAmount, totalPaidAmount, totalOverpaymentRemaining],
  );

  const settlementAmount = useMemo(
    () => (adminSidePaid - tenantSidePaid - otherReceivables).toFixed(2),
    [adminSidePaid, tenantSidePaid, otherReceivables],
  );

  const howShowFinalAmount = useCallback(() => settlementAmount, [settlementAmount]);

  const setFinalAmount = (value, type) => {
    if (type === 1) {
      setMaintenanceCharges(parseCurrency(value));
    } else if (type === 2) {
      setRefurbismentCharges(parseCurrency(value));
    } else if (type === 3) {
      setAdminCharges(parseCurrency(value));
    } else if (type === 4) {
      setDeductionCharges(parseCurrency(value));
    }
  };

  const openLinkedInvoiceModal = (field: LinkedInvoicePaymentType) => {
    setActiveLinkedInvoiceField(field);
  };

  const closeLinkedInvoiceModal = () => {
    setActiveLinkedInvoiceField(null);
  };

  const applyLinkedInvoiceToField = (field: LinkedInvoicePaymentType, invoice: LinkedInvoice) => {
    const amount = getLinkedInvoiceAmount(invoice);

    if (field === "maintenanceFee") {
      setValue("maintenanceFee", amount, { shouldDirty: true });
      setMaintenanceCharges(amount);
    } else if (field === "refurbismentFee") {
      setValue("refurbismentFee", amount, { shouldDirty: true });
      setRefurbismentCharges(amount);
    } else if (field === "adminFee") {
      setValue("adminFee", amount, { shouldDirty: true });
      setAdminCharges(amount);
    }
  };

  const getLinkedInvoiceFormFieldName = (field: LinkedInvoicePaymentType) => {
    if (field === "maintenanceFee") return "maintenanceFee";
    if (field === "refurbismentFee") return "refurbismentFee";
    if (field === "adminFee") return "adminFee";
    if (field === "Overstay") return "overStayPenalty";
    if (field === "terminationCharges") return "terminationPenalty";
    return null;
  };

  const getOriginalLinkedInvoiceFieldValue = (field: LinkedInvoicePaymentType) => {
    if (field === "maintenanceFee") return moveOutDetail?.settlementSummary?.maintenancefee || 0;
    if (field === "refurbismentFee") return moveOutDetail?.settlementSummary?.refurbismentfee || 0;
    if (field === "adminFee") return moveOutDetail?.settlementSummary?.otheradminfee || 0;
    if (field === "Overstay") return getOverStayPenaltyValue(moveOutDetail) || 0;
    if (field === "terminationCharges") return getTerminationPaneltyValue(moveOutDetail) || 0;
    return 0;
  };

  const restoreValueBeforeLinkedInvoice = (field: LinkedInvoicePaymentType) => {
    const fieldName = getLinkedInvoiceFormFieldName(field);
    if (!fieldName) return;

    const previousValue = valueBeforeLinkedInvoiceRef.current[field];
    const valueToRestore = previousValue ?? getOriginalLinkedInvoiceFieldValue(field);

    hasUserChangedPenaltyRef.current = false;
    setValue(fieldName, valueToRestore, { shouldDirty: true });

    if (field === "maintenanceFee") {
      setMaintenanceCharges(parseCurrency(valueToRestore));
    } else if (field === "refurbismentFee") {
      setRefurbismentCharges(parseCurrency(valueToRestore));
    } else if (field === "adminFee") {
      setAdminCharges(parseCurrency(valueToRestore));
    }

    delete valueBeforeLinkedInvoiceRef.current[field];
  };

  const getLinkedInvoiceDisplayValue = (field: LinkedInvoicePaymentType) => {
    const linkedInvoice = linkedInvoices[field];
    if (!linkedInvoice) return "";

    return [
      linkedInvoice.invoiceNumber ? `${linkedInvoice.invoiceNumber}` : null,
      convertToNormalCase(linkedInvoice.description || linkedInvoiceFieldLabels[field]),
      formatCurrency(linkedInvoice.totalAmount),
      getLinkedInvoiceStatusLabel(field),
    ]
      .filter(Boolean)
      .join("   ");
  };

  const getLinkedInvoiceStatusLabel = (field: LinkedInvoicePaymentType) => {
    const linkedInvoice = linkedInvoices[field];
    return String(linkedInvoice?.chequeStatus || linkedInvoice?.status || "").toLowerCase() === "paid" ? "Paid" : "Unpaid";
  };

  const renderLinkedInvoiceDisplayField = (field: LinkedInvoicePaymentType, label: string) => (
    <InputField
      control={control}
      setValue={setValue}
      disabled={true}
      label={label}
      fieldname={`${field}LinkedInvoice`}
      valueGot={getLinkedInvoiceDisplayValue(field)}
    />
  );

  const handleAddLinkedInvoice = (invoice: LinkedInvoice) => {
    if (!activeLinkedInvoiceField) return;
    const fieldName = getLinkedInvoiceFormFieldName(activeLinkedInvoiceField);

    if (fieldName && !(activeLinkedInvoiceField in valueBeforeLinkedInvoiceRef.current)) {
      valueBeforeLinkedInvoiceRef.current[activeLinkedInvoiceField] = getValues(fieldName);
    }

    setLinkedInvoices((prev) => ({
      ...prev,
      [activeLinkedInvoiceField]: invoice,
    }));
    applyLinkedInvoiceToField(activeLinkedInvoiceField, invoice);
    closeLinkedInvoiceModal();
  };

  const removeLinkedInvoice = (field: LinkedInvoicePaymentType) => {
    restoreValueBeforeLinkedInvoice(field);
    setLinkedInvoices((prev) => ({
      ...prev,
      [field]: null,
    }));
  };

  const renderLinkedInvoiceAction = (field: LinkedInvoicePaymentType, applyPosition: string = "static") => {
    const linkedInvoice = linkedInvoices[field];

    return (
      <div style={{ marginTop: 2 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 8,
            position: applyPosition as "static" | "absolute",
                  right: "14px",
                  zIndex: 1000,
          }}
        >
          <span style={{ color: "#184461", fontSize: 12, fontWeight: 600 }}>Link to existing invoice</span>
          <Switch
            size="small"
            checked={Boolean(linkedInvoice)}
            onChange={(checked) => {
              if (checked) {
                openLinkedInvoiceModal(field);
              } else {
                removeLinkedInvoice(field);
              }
            }}
          />
        </div>
      </div>
    );
  };

  const getMoveOutDetail = async () => {
    let response = await getMoveOutDetailService(leaseId, vacatingDate?.slice(0, 10));
    if (response) {
      response?.vacatingDate && setValue("moveOutDate", dateBookingDDMMYYFormat(response?.vacatingDate));
      maintenanceCharges === 0 &&
        setMaintenanceCharges(
          response?.settlementSummary?.maintenancefee ? response?.settlementSummary?.maintenancefee : 0,
        );
      refurbismentCharges === 0 &&
        setRefurbismentCharges(
          response?.settlementSummary?.refurbismentfee ? response?.settlementSummary?.refurbismentfee : 0,
        );
      adminCharges === 0 &&
        setAdminCharges(response?.settlementSummary?.otheradminfee ? response?.settlementSummary?.otheradminfee : 0);
      deductionCharges === 0 &&
        setDeductionCharges(response?.settlementSummary?.deduction ? response?.settlementSummary?.deduction : 0);
      if (response?.settlementSummary?.linkedInvoices?.length) {
        const resolvedLinkedInvoices = resolveLinkedInvoicesFromSummary(
          response?.paymentSchedule || [],
          response?.settlementSummary?.linkedInvoices,
        );
        setLinkedInvoices(resolvedLinkedInvoices);

        if (resolvedLinkedInvoices.maintenanceFee) {
          setMaintenanceCharges(getLinkedInvoiceAmount(resolvedLinkedInvoices.maintenanceFee));
        }
        if (resolvedLinkedInvoices.refurbismentFee) {
          setRefurbismentCharges(getLinkedInvoiceAmount(resolvedLinkedInvoices.refurbismentFee));
        }
        if (resolvedLinkedInvoices.adminFee) {
          setAdminCharges(getLinkedInvoiceAmount(resolvedLinkedInvoices.adminFee));
        }
      }
      setMoveOutDetail(response);
    }
  };

  useEffect(() => {
    getMoveOutDetail();
  }, [vacatingDate]);

  const isBooking = moveOutDetail && Object.keys(moveOutDetail).length > 0;

  const addonBefore = (options, defaultValue, onChange) => {
    return (
      <Select
        onChange={(e) => onChange(e)}
        className="beforAddOnSelect"
        defaultValue={defaultValue || options[0]}
        options={options || []}
        style={{ width: 100 }}
      />
    );
  };

  let moveOutType = moveOutDetail?.moveOutType?.toLowerCase();

  return (
    <>
      {!isBooking && (
        <Row gutter={24} className="loading">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "500px",
              width: "100%",
            }}
          >
            <Spin size="large" />
          </div>
        </Row>
      )}

      {isBooking && (
        <>
          <PdfView pdfData={viewOrDownloadUrl} openFileView={openFileView} setOpenFileView={setOpenFileView} />
          <Modal
            centered
            footer={null}
            width="800px"
            className="bd-modal"
            open={Boolean(activeLinkedInvoiceField)}
            title={
              activeLinkedInvoiceField
                ? `Link Invoice - ${linkedInvoiceFieldLabels[activeLinkedInvoiceField]}`
                : "Link Invoice"
            }
            destroyOnClose
            onCancel={closeLinkedInvoiceModal}
            maskClosable={false}
          >
            <LinkedInvoicesGrid
              invoices={filteredLinkedInvoiceOptions}
              linkedInvoiceIds={linkedInvoiceIds as string[]}
              onAddInvoice={handleAddLinkedInvoice}
            />
          </Modal>

          <Form
            layout="vertical"
            name="bookingform"
            scrollToFirstError
            className="bf-main"
            onFinish={handleSubmit(onSubmit)}
          >
            <Loading visible={visible} />

            <Col span={24}>
              <Row gutter={24}>
                <Col span={8}>
                  <ReactSelectField
                    control={control}
                    setValue={setValue}
                    label="Penalty Type"
                    fieldname="penaltyType"
                    selectOption={penaltyOption}
                    iProps={{ placeholder: "Select", isDisabled: true }}
                    rules={{ required: "Please select one" }}
                    validate={errors.penaltyType && "error"}
                    validMessage={errors.penaltyType && errors.penaltyType.message}
                    valueGot={penaltyOption?.find((item) => item?.value === moveOutDetail?.moveOutType?.toLowerCase())}
                  />
                </Col>

                <Col span={8}>
                  <DateField
                    control={control}
                    allowClear={false}
                    setValue={setValue}
                    label="Move-out Date"
                    fieldname="moveOutDate"
                    valueGot={dateBookingDDMMYYFormat(vacatingDate)}
                    onChange={(e) => seVacatingDate("20" + moment(e?.$d).format("YY-MM-DD"))}
                    iProps={{
                      format: datePlaceholderddmmyyFormat,
                      placeholder: datePlaceholderddmmyyFormat,
                    }}
                  />
                </Col>

                <Col span={7}>
                  <div
                    style={{
                      position: "absolute",
                      right: "14px",
                      top: "-10px",
                    }}
                  >
                    <InputCheckbox
                      fieldname="moveOutConfirm"
                      label="Complete"
                      control={control}
                      classes={`prm-checkbox`}
                      valueGot={
                        bookingDetails?.moveOutInspection ? bookingDetails?.moveOutInspection?.moveOutConfirm : false
                      }
                      iProps={{
                        className: `prm-checkbox`,
                      }}
                      setValue={setValue}
                    />
                    {(uploadedDocData?.documentId ||
                      (bookingDetails["moveOutInspection"] && bookingDetails?.moveOutInspection["documentId"])) && (
                      <Tooltip title="View" trigger="hover" showArrow={false}>
                        <Button
                          title={"View"}
                          label={<DownloadOutlined />}
                          type="button"
                          style={{
                            marginTop: "25px",
                            zIndex: 999,
                            top: "-43px",
                            left: "114px",
                          }}
                          className="ef-action-btn"
                          onClick={() =>
                            preViewDoc(
                              bookingDetails["moveOutInspection"] &&
                                (bookingDetails?.moveOutInspection["documentId"]
                                  ? bookingDetails?.moveOutInspection["documentId"]
                                  : uploadedDocData?.documentId),
                            )
                          }
                          myClassSet={true}
                        />
                      </Tooltip>
                    )}
                  </div>

                  <DateField
                    control={control}
                    setValue={setValue}
                    allowClear={false}
                    label="Move-out Inspection Date"
                    fieldname="moveOutInspectionDate"
                    valueGot={dateBookingDDMMYYFormat(
                      bookingDetails?.moveOutInspection && bookingDetails?.moveOutInspection["date"],
                    )}
                    iProps={{
                      format: datePlaceholderddmmyyFormat,
                      placeholder: datePlaceholderddmmyyFormat,
                    }}
                  />
                </Col>

                <Col span={1}>
                  <Space size={20}>
                    <Upload {...fileProps}>
                      <span>
                        {(bookingDetails["moveOutInspection"] && !bookingDetails?.moveOutInspection["documentId"]) ||
                        !uploadedDocData?.documentId ? (
                          <LinkOutlined style={{ marginTop: "30px", fontSize: "25px" }} />
                        ) : (
                          <Tooltip title="Upload" trigger="hover" showArrow={false}>
                            <Button
                              title={"upload"}
                              label={<UploadOutlined />}
                              type="button"
                              style={{ marginTop: "25px" }}
                              className="ef-action-btn"
                              myClassSet={true}
                            />
                          </Tooltip>
                        )}
                      </span>
                    </Upload>
                  </Space>
                </Col>

                <Col span={8}>
                  <InputField
                    control={control}
                    disabled={true}
                    setValue={setValue}
                    label="Lease Term"
                    fieldname="leaseTerm"
                    valueGot={`${moveOutDetail?.leaseTermDays ? moveOutDetail?.leaseTermDays : 0} days |  ${formatCurrency(
                      moveOutDetail?.leaseTerms?.contractAmount,
                      { showZeros: true },
                    )}`}
                    validate={errors.leaseTerm && "error"}
                    validMessage={errors.leaseTerm && errors.leaseTerm.message}
                  />
                </Col>

                <Col span={8}>
                  <InputField
                    control={control}
                    setValue={setValue}
                    disabled={true}
                    label="Days Occupied"
                    fieldname="daysOccupied"
                    valueGot={`${moveOutDetail?.daysOccupied ? moveOutDetail?.daysOccupied : 0} days`}
                    validate={errors.daysOccupied && "error"}
                    validMessage={errors.daysOccupied && errors.daysOccupied.message}
                  />
                </Col>

                <Col span={8}>
                  <InputField
                    control={control}
                    setValue={setValue}
                    disabled={true}
                    label="Rent Per Day"
                    disable={true}
                    fieldname="rentPerDay"
                    valueGot={` ${formatCurrency(moveOutDetail?.rentPerDay, { showZeros: true })}`}
                    validate={errors.rentPerDay && "error"}
                    validMessage={errors.rentPerDay && errors.rentPerDay.message}
                  />
                </Col>

                <Col span={8}>
                  <InputField
                    control={control}
                    setValue={setValue}
                    disabled={true}
                    label="Security Deposit"
                    fieldname="securityDeposit"
                    valueGot={`${securityDepositDate} |  ${formatCurrency(securityDepositAmount, { showZeros: true })}`}
                    validate={errors.securityDeposit && "error"}
                    validMessage={errors.securityDeposit && errors.securityDeposit.message}
                  />
                </Col>

                <Col span={8}>
                  <InputField
                    control={control}
                    setValue={setValue}
                    disabled={true}
                    label="Rent Received Until"
                    fieldname="rentReceived"
                    valueGot={`${lastPaidDate} |  ${formatCurrency(totalPaidAmount, { showZeros: true })}`}
                    validate={errors.rentReceived && "error"}
                    validMessage={errors.rentReceived && errors.rentReceived.message}
                  />
                </Col>

                <Col span={8}>
                  <InputField
                    control={control}
                    setValue={setValue}
                    disabled={true}
                    label="Actual Rent Due"
                    fieldname="rentDue"
                    valueGot={`${moveOutDetail?.daysOccupied ? moveOutDetail?.daysOccupied : 0} days | ${formatCurrency(
                      moveOutDetail?.actualRentDue,
                      { showZeros: true },
                    )}`}
                    validate={errors.rentDue && "error"}
                    validMessage={errors.rentDue && errors.rentDue.message}
                  />
                </Col>

                <Col span={8}>
                  <InputField
                    control={control}
                    setValue={setValue}
                    disabled={true}
                    label="Unpaid Dues"
                    disable={true}
                    fieldname="otherUnpaidDuesAmount"
                    valueGot={`${formatCurrency(moveOutDetail?.otherUnpaidDuesAmount, { showZeros: true })}`}
                  />
                </Col>
                <Col span={8}>
                  <InputField
                    control={control}
                    setValue={setValue}
                    disabled={true}
                    label="Overpayment Credit"
                    disable={true}
                    fieldname="overPayment"
                    valueGot={`${formatCurrency(totalOverpaymentRemaining, { showZeros: true })}`}
                  />
                </Col>
               
                <Col span={8}>
                  {renderLinkedInvoiceAction("maintenanceFee","absolute")}
                  {linkedInvoices.maintenanceFee ? (
                    renderLinkedInvoiceDisplayField("maintenanceFee", "Maintenance Fee (if any)")
                  ) : (
                    <InputNumberField
                      control={control}
                      onChange={(e) => setFinalAmount(e, 1)}
                      format="currency"
                      fieldname="maintenanceFee"
                      defaultValue={`${formatCurrency(moveOutDetail?.settlementSummary?.maintenancefee, {
                        showZeros: true,
                        symbol: false,
                      })} `}
                      label="Maintenance Fee (if any)"
                    />
                  )}
                </Col>

                <Col span={8}>
                  {renderLinkedInvoiceAction("refurbismentFee","absolute")}
                  {linkedInvoices.refurbismentFee ? (
                    renderLinkedInvoiceDisplayField("refurbismentFee", "Refurbishment Fee (if any)")
                  ) : (
                    <InputNumberField
                      control={control}
                      onChange={(e) => setFinalAmount(e, 2)}
                      format="currency"
                      fieldname="refurbismentFee"
                      defaultValue={`${formatCurrency(moveOutDetail?.settlementSummary?.refurbismentfee, {
                        showZeros: true,
                        symbol: false,
                      })} `}
                      label="Refurbishment Fee (if any)"
                    />
                  )}
                </Col>

                <Col span={8}>
                  {renderLinkedInvoiceAction("adminFee","absolute")}
                  {linkedInvoices.adminFee ? (
                    renderLinkedInvoiceDisplayField("adminFee", "Other / Admin Fee (if any)")
                  ) : (
                    <InputNumberField
                      control={control}
                      onChange={(e) => setFinalAmount(e, 3)}
                      format="currency"
                      fieldname="adminFee"
                      defaultValue={` ${formatCurrency(moveOutDetail?.settlementSummary?.otheradminfee, {
                        showZeros: true,
                        symbol: false,
                      })} `}
                      label="Other / Admin Fee (if any)"
                    />
                  )}
                </Col>
                <Col span={8}>
                  <InputNumberField
                    control={control}
                    onChange={(e) => setFinalAmount(e, 4)}
                    format="currency"
                    fieldname="waiver"
                    defaultValue={` ${formatCurrency(moveOutDetail?.settlementSummary?.deduction, {
                      showZeros: true,
                      symbol: false,
                    })} `}
                    label="Deduction / Waiver"
                  />
                </Col>
                {moveOutType === "late" && (
                  <>
                    <Col span={8}>
                      <InputNumberField
                        control={control}
                        disabled={Boolean(linkedInvoices.Overstay)}
                        // onChange={(e) => setFinalAmount(e, 3)}
                        addonBefore={() =>
                          addonBefore(
                            moveOutDetail?.overstayPaneltyFields,
                            moveOutDetail?.overstay?.type,
                            setOvertStayPenaltyType,
                          )
                        }
                        inputNumberProps={{
                          min: 0,
                          max: overStayPenaltyType === "percentage" ? 100 : undefined,
                          precision: 2,
                        }}
                       
                        format="currency"
                        fieldname="overStayPenalty"
                        onChange={() => {
                          hasUserChangedPenaltyRef.current = true;
                        }}
                        defaultValue={`${formatCurrency(getOverStayPenaltyValue(moveOutDetail), {
                          showZeros: true,
                          symbol: false,
                        })} `}
                        stringMode={false}
                        label={`OverStay Penalty Type (inc vat ${moveOutDetail?.overStayPenalty?.vat}%)`}
                      />
                    </Col>
                    
                    <Col span={8}>
                      <div style={{display: "flex", gap: "10px", alignItems: "center", position: "absolute", right: "14px", zIndex: 999 }}>

                        {/* <div>{renderLinkedInvoiceAction("Overstay", "static")}</div> */}
                        <Tooltip
                          placement="top"
                          overlayInnerStyle={{
                            backgroundColor: "#030218",
                            color: "#ffffff",
                            width: "450px",
                          }} // Custom styles
                          title={<TooltipContent data={moveOutDetail?.overstay} type={1} />}
                        >
                          <ExclamationCircleFilled title={moveOutDetail?.overstay?.overStayPaneltyFrom} />
                        </Tooltip>
                      </div>
                      
                      {linkedInvoices.Overstay ? (
                        renderLinkedInvoiceDisplayField("Overstay", "OverStay")
                      ) : (
                        <InputField
                          control={control}
                          setValue={setValue}
                          label="OverStay"
                          disabled={true}
                          fieldname="Overstay"
                          valueGot={
                            penaltyChangeLoading
                              ? "Loading..."
                              : `${
                                  moveOutDetail?.overstay?.numberOfDays ? moveOutDetail?.overstay?.numberOfDays : 0
                                } days |  ${formatCurrency(moveOutDetail?.overstay?.totalOverStayPaneltyAmount, {
                                  showZeros: true,
                                })}`
                          }
                        />
                      )}
                    </Col>
                  </>
                )}

                {moveOutType === "early" && (
                  <>
                    <Col span={8}>
                      <InputNumberField
                        control={control}
                        disabled={Boolean(linkedInvoices.terminationCharges)}
                        // onChange={(e) => setFinalAmount(e, 3)}
                        addonBefore={() =>
                          addonBefore(
                            moveOutDetail?.terminationPaneltyFields,
                            moveOutDetail?.termination?.type,
                            setTerminationPenaltyType,
                          )
                        }
                        inputNumberProps={{
                          min: 0,
                          max: terminationPenaltyType === "month" ? 12 : undefined,
                          precision: 2,
                        }}
                        stringMode={false}
                        format="currency"
                        fieldname="terminationPenalty"
                        onChange={() => {
                          hasUserChangedPenaltyRef.current = true;
                        }}
                        defaultValue={` ${formatCurrency(getTerminationPaneltyValue(moveOutDetail), {
                          showZeros: true,
                          symbol: false,
                        })} `}
                        label={`Termination Penalty Type (inc vat ${moveOutDetail?.earlyTerminationPenalty?.vat}%)`}
                      />
                    </Col>
                    <Col span={8}>
                   
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          position: "absolute",
                          right: "14px",
                          zIndex: 9999,
                        }}
                      >
                       <div>     {renderLinkedInvoiceAction("terminationCharges","static")}</div>
                        <div>
                        <Tooltip
                          placement="top"
                          overlayInnerStyle={{
                            backgroundColor: "#030218",
                            color: "#ffffff",
                            width: "500px",
                          }} // Custom styles
                          title={<TooltipContent data={moveOutDetail?.termination} type={2} />}
                        >
                          <ExclamationCircleFilled title={moveOutDetail?.termination?.terminationPaneltyFrom} />
                        </Tooltip>
                        </div>
                      </div>
                    
                      {linkedInvoices.terminationCharges ? (
                        renderLinkedInvoiceDisplayField("terminationCharges", "Termination Charges")
                      ) : (
                        <InputField
                          control={control}
                          disabled={true}
                          setValue={setValue}
                          label="Termination Charges"
                          fieldname="terminationCharges"
                          valueGot={
                            penaltyChangeLoading
                              ? "Loading..."
                              : `${
                                  moveOutDetail?.termination?.numberOfDays ? moveOutDetail?.termination?.numberOfDays : 0
                                } days |  ${formatCurrency(moveOutDetail?.termination?.totalterminationPaneltyAmount, {
                                  showZeros: true,
                                })}`
                          }
                          validate={errors.terminationCharges && "error"}
                          validMessage={errors.terminationCharges && errors.terminationCharges.message}
                        />
                      )}
                    </Col>
                  </>
                )}
 <Col span={8}>
                  <InputField
                    control={control}
                    setValue={setValue}
                    disabled={true}
                    label="Other Receivables"
                    disable={true}
                    fieldname="otherReceivables"
                    valueGot={`${formatCurrency(-otherReceivables, { showZeros: true })}`}
                  />
                </Col>
                <Col span={8}>
                  <InputField
                    control={control}
                    setValue={setValue}
                    disabled={true}
                    label="Settlement Amount"
                    fieldname="settlementAmount"
                    valueGot={` ${formatCurrency(settlementAmount, { showZeros: true })}`}
                    helpingText={Number(settlementAmount) > 0 ? "Payable by Tenant" : "Payable to Tenant"}
                  />
                </Col>
              </Row>

              <Row gutter={24} className="footer">
                <Space size="middle">
                  <Button
                    label="Cancel"
                    className="bf-discard-button"
                    onClick={() => props.parentState({ modalPayload: { open: false } })}
                  />

                  <Button type="submit" label="Save" className="cc-fotter_next-button" />
                </Space>
              </Row>
            </Col>
          </Form>
        </>
      )}
    </>
  );
};

export default React.memo(index);
